import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { PiniaSharedState } from 'pinia-shared-state'
import { markRaw } from 'vue'
import router from '../router'
import { makeDebouncedStorage } from './debouncedStoragePersistence.js'

const pinia = createPinia()
pinia.use(createPersistedState({ storage: makeDebouncedStorage(localStorage, 500) }))
pinia.use(PiniaSharedState({ enable: false }))
pinia.use(({ store }) => {
  store.router = markRaw(router)
})
export default pinia
